import { ArticleHeading4, Link, type TPlacement, TooltipDesktop, UIHeading5, UIText2 } from '@cian/ui-kit';

import { type FC } from 'react';

import { stopPropagation } from '@/packages/utils/event';

import { type IVas } from '../../../../types/vas';

import * as styles from './PromotionDescription.css';

type TPromotionDescriptionProps = {
  promotionDescription: string;
  item: IVas[];
  isBet: boolean;
  tooltipPosition: TPlacement;
};

export const PromotionDescription: FC<TPromotionDescriptionProps> = ({
  item,
  promotionDescription,
  isBet,
  tooltipPosition,
}) => {
  return (
    <div className={styles['wrapper']} data-testid="card.promotion">
      {!isBet || !item.length ? (
        <UIText2 color="decorative-deeporange-vas" fontWeight="bold">
          {promotionDescription}
        </UIText2>
      ) : (
        <TooltipDesktop
          placement={tooltipPosition}
          theme="white"
          title={
            <div className={styles['tooltip-content']} data-testid="card.promotion-tooltip">
              <ArticleHeading4 as="h4">Действуют услуги</ArticleHeading4>

              {item.map(vas => (
                <div key={`vas-${vas.type}`}>
                  <UIHeading5 as="p" color="decorative-deeporange-vas" fontWeight="bold">
                    {vas.name}
                  </UIHeading5>
                  <UIText2 as="p">{vas.description}</UIText2>
                </div>
              ))}

              <div>
                <Link
                  fontSize="S"
                  href="https://support.cian.ru/ru/knowledge_base/art/94/cat/179/"
                  rel="noreferrer"
                  spacingSize="XS"
                  target="_blank"
                  onClick={stopPropagation}
                >
                  Узнать подробнее
                </Link>
              </div>
            </div>
          }
        >
          <UIText2 color="decorative-deeporange-vas" display="inline" fontWeight="bold">
            {promotionDescription}
          </UIText2>
        </TooltipDesktop>
      )}
    </div>
  );
};
